export default "__VITE_ASSET__BxN6_vDt__"